<template>
    <BaseSection
        section-width="content-lg"
        class="newsletter-signup"
        :class="{
            'newsletter-signup--success': success,
            'newsletter-signup--error': error,
        }"
    >
        <template #title>Blijf op de hoogte van jouw buurt</template>
        <template #description>Schrijf je in voor de nieuwsbrief</template>

        <MailchimpSubscribe
            v-model:email="email"
            :url="mailchimp.url"
            :user-id="mailchimp.userId"
            :audience-id="mailchimp.audienceId"
            @error="onError"
            @success="onSuccess"
        >
            <template #default="{ subscribe, loading }">
                <form class="newsletter-signup__form" @submit.prevent="subscribe">
                    <label for="newsletter-input" class="sr-only">E-mailadres</label>
                    <input
                        id="newsletter-input"
                        v-model="email"
                        type="email"
                        placeholder="Jouw e-mailadres"
                        required
                        class="newsletter-signup__input"
                        aria-errormessage="newsletter-error"
                        :disabled="loading"
                        @focus="handleFocus"
                    >
                    <BaseButton
                        type="submit"
                        class="newsletter-signup__submit"
                        :icon="!error && !success ? 'marker:arrow_1_right' : null"
                        :loading
                        :label="loading ? 'Bezig…' : buttonLabel"
                    />
                </form>

                <div v-if="error && !loading" id="newsletter-error" class="newsletter-signup__error" role="alert">
                    <Icon name="app:warning" />
                    Er ging iets mis – probeer het opnieuw
                </div>
            </template>
        </MailchimpSubscribe>

        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1147 640" class="newsletter-signup__background-shape">
            <path stroke="#000" d="M89.71 451.2c173.011 28.8 916.32 57.6 945.15 54.4C1063.7 502.4 153.788 256 137.768 256c-16.019 0 778.55 54.4 804.182 54.4 25.631 0-663.21-211.2-676.025-214.4-12.816-3.2 724.083 60.8 768.935 54.4" />
            <path fill="#fff" d="M676.076 44.5c-5.593-.356-58.335-5.59-74.584-5.59-16.249 0-60.555-10.114-81.332-10.114-20.777 0-76.893-10.647-93.675-10.647-16.781 0-60.555-3.904-69.612-3.904-9.056 0-20.155-6.21-28.59-5.59-8.435.622-24.684-2.838-36.316-2.838-11.631 0-21.576-.799-32.408-3.283-10.833-2.484-28.236-4.17-36.493 0-8.258 4.17-15.805 5.767-22.376 8.251-6.57 2.484-5.771 19.874-5.771 31.496 0 11.623 1.687 33.98 2.486 43.119.799 9.138 4.173 12.42 1.687 19.075-2.486 6.654 4.173 15.792 6.659 22.358 2.487 6.565-1.687 11.622-5.771 18.276s-29.922 0-50.611-3.282c-20.777-3.283-52.297-4.969-73.874-3.283-21.576 1.686-51.498 12.421-54.784 26.528-3.285 14.106 0 36.464.8 43.917.799 7.452 14.916 18.276 15.804 23.245.888 4.968-13.318 12.421-15.804 18.276-2.487 5.856 14.117 32.384 14.117 38.151 0 5.766-6.66 9.138-9.944 15.792-3.286 6.654 7.458 15.792 7.458 23.245 0 7.453 12.43 7.453 21.576 7.453h46.527c11.631 0 33.207 9.138 37.381 9.936 4.173.799 2.486 10.824 13.318 13.309 10.833 2.484 28.236 3.282 28.236 8.251 0 4.968-16.604 2.484-27.437 2.484-10.832 0-57.27-14.107-78.846-14.905-21.576-.799-57.27-1.686-67.215 4.17-9.944 5.855-6.659 14.106-3.64 24.842 3.019 10.735 1.154 46.49.178 62.193-.977 15.704 1.775 68.05.088 77.099-1.687 9.05 18.291 11.534 25.75 12.421 10.033 1.153 61.532 39.836 101.932 47.111 40.399 7.275 101.576 7.275 150.944 11.8 49.368 4.525 134.696 20.761 193.564 23.511 58.868 2.839 250.212 11.179 331.545 17.922 81.332 6.743 180.689 5.057 208.747 2.218 28.06-2.839 83.64 1.153 96.52 0 12.87-1.153 18.55-17.389 20.77-28.036 2.22-10.647 7.28-77.365 8.97-86.858 1.69-9.493-3.91-33.626 2.22-51.547 6.13-17.922 2.22-56.605-14.56-59.444-16.78-2.839-109.39-28.036-117.29-29.189-7.91-1.153-11.19-9.493-11.19-25.818 0-16.325-1.16-15.704-2.843-24.664-1.687-8.961 14.033-12.333 8.433-27.504-5.59-15.171-2.84-19.075-2.22-35.311.54-16.236 6.22-20.761 17.41-20.761 11.18 0 42.61-.532 51.05 1.153 8.44 1.686 20.16 2.839 28.06-7.807 7.9-10.647 15.18-31.94 15.18-42.054s-2.84-35.311-5.06-43.74c-2.22-8.428 6.22-22.535 5.59-31.407-1.06-15.438-1.06-65.743-11.98-67.96-10.92-2.219-206.708 0-227.485 0-20.777 0-191.699-11.623-200.933-12.244l-.356.177Z" />
        </svg>
    </BaseSection>
</template>

<script setup>
const { public: { mailchimp }} = useRuntimeConfig();

const email = ref('');
const success = ref(false);
const error = ref(false);

const buttonLabel = computed(() => {
    if (success.value) { return 'Gelukt!'; }
    if (error.value) { return 'Mislukt'; }
    return 'Verstuur';
});

function handleFocus() { // reset states on input focus
    error.value = false;
    success.value = false;
}

const onError = (v) => {
    success.value = false;
    error.value = v;
};

const { push } = useTagmanager();
const onSuccess = (v) => {
    error.value = false;
    success.value = v;

    push({
        event: 'newsletter_signup'
    });
};
</script>

<style lang="less" src="./NewsletterSignup.less" />
